import React, { useEffect, useState } from 'react';

import StarBarRatingItem from './star-bar-rating-item/star-bar-rating-item';

import styles from './star-bar-rating.scss';

export interface RatingSummary {
  count?: number;
  rating: number | string;
}

interface StarBarRatingProps {
  heading?: string;
  headingTag?: keyof JSX.IntrinsicElements;
  noDataMessage?: string;
  ratingSummaries?: RatingSummary[];
  totalCount: number;
}

function sortRatingSummaries(summaries) {
  return [...summaries].sort(
    (a, b) => parseFloat(b?.rating) - parseFloat(a?.rating)
  );
}

function StarBarRating(props: StarBarRatingProps) {
  const {
    heading,
    headingTag: HeadingTag = 'h5',
    noDataMessage,
    ratingSummaries,
    totalCount
  } = props;

  const [sortedRatingSummaries, setSortedRatingSummaries] = useState<
    RatingSummary[]
  >([]);

  useEffect(() => {
    setSortedRatingSummaries(
      Array.isArray(ratingSummaries) ? sortRatingSummaries(ratingSummaries) : []
    );
  }, [ratingSummaries]);

  return (
    <div className={styles['container']}>
      <div className={styles['by-review']}>
        {heading && (
          <HeadingTag className={styles['section-heading']}>
            {heading}
          </HeadingTag>
        )}
        {sortedRatingSummaries.length > 0
          ? sortedRatingSummaries.map((ratingSummary, idx) => (
              <StarBarRatingItem
                key={idx}
                ratingSummary={ratingSummary}
                totalCount={totalCount}
              />
            ))
          : noDataMessage && <div>{noDataMessage}</div>}
      </div>
    </div>
  );
}

export { StarBarRatingItem };
export default StarBarRating;
